import {AxiosInstance} from 'axios';
import {$activeFile} from '../../../stores/activeFileStore';

const ACTIVE_FILE_ID_HEADER = 'X-Resware-AI-Active-File-Id';

/**
 * Attach the active ResWare file id (provided by the desktop host) to outbound requests
 * so backend AI services can answer questions about the file the user is on without the
 * user specifying it. Only sent when a file is active.
 */
export function addActiveFileIdInterceptor(instance: AxiosInstance): void {
  instance.interceptors.request.use(config => {
    const activeFile = $activeFile.get();
    if (activeFile) {
      config.headers[ACTIVE_FILE_ID_HEADER] = String(activeFile.fileId);
    }
    return config;
  });
}
